import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { environment } from '#environments';
import { Dtos } from '#models';

@Injectable({
  providedIn: 'root',
})
export class SubCategoryService {
  private http = inject(HttpClient);

  public getSubCategories(): Observable<Dtos.SubCategory[]> {
    return this.http.get<Dtos.SubCategory[]>(`${environment.apiUrl}/subcategory`);
  }

  public createSubCategory(subCategory: Dtos.SubCategory): Observable<Dtos.SubCategory> {
    return this.http.post<Dtos.SubCategory>(`${environment.apiUrl}/subcategory`, subCategory);
  }

  public updateSubCategory(subCategory: Dtos.SubCategory): Observable<Dtos.SubCategory> {
    return this.http.put<Dtos.SubCategory>(`${environment.apiUrl}/subcategory`, subCategory);
  }

  public deleteSubCategory(id: number): Observable<Dtos.SubCategory> {
    return this.http.delete<Dtos.SubCategory>(`${environment.apiUrl}/subcategory/${id}`);
  }
}
